import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../Button/Button';
import Icon from '../Icon/Icon';
import Modal from '../Modal';
import styles from './DeleteApprovalsCommentModal.module.scss';

const DeleteApprovalsCommentModal = ({ confirmDeletion, isShow, onClose }) => {
  const { t } = useTranslation();

  const handleDelete = () => {
    confirmDeletion();
    onClose();
  };

  return (
    <Modal className={styles.modal} open={isShow} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>{t('approvals.comment.delete_modal_header')}</span>
          <Icon src="close" className={styles.closeIcon} onClick={onClose} />
        </div>
        <div className={styles.text}>
          <span>{t('approvals.comment.modal_text')}</span>
        </div>
        <div className={styles.buttonsContainer}>
          <CustomButton variant="secondary" label={t('general.cancel')} onClick={onClose} />
          <CustomButton className={styles.removeBtn} variant="primary" label={t('general.delete')} onClick={handleDelete} />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteApprovalsCommentModal;
